import React, {useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router-dom';
import {AgyleLogoIcon} from '../../components/icons/icons';
import AgyleButton from '../../components/ui/buttons/agyleButton';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        height: '100vh',
        // width: '100vw',
        color: '#000',
        backgroundColor: '#fff',
        fontWeight: 600,
        gap: 10,
    },
    opps: {
        fontSize: 48,
    },
    title: {
        fontSize: 24,
    },
    message: {
        fontSize: 14,
    },
    refresh: {
        padding: '0 5px',
        color: '#2180f7',
        cursor: 'pointer',
    },
}));

const DefaultErrorPage = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const history = useHistory();

    let params = new URLSearchParams(window.location.search);
    let iFrameAdmission = false;
    iFrameAdmission = (params?.get("view") === "admissions_iframe");
    iFrameAdmission = (params?.get("view") === "admissions_patient_iframe") || iFrameAdmission;

    const handleGoBack = () => {
        history.push('/');
        window.location.reload();
    };

    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <div className={classes.root}>
            <AgyleLogoIcon style={{fontSize: 124}}/>

            <div className={classes.opps}>
                Oops!
            </div>

            <div className={classes.title}>
                {t('errorPage.title')}
            </div>

            <div className={classes.message}>
                <span>
                    {t('errorPage.messagePart1')}
                </span>

                <span
                    onClick={handleRefresh}
                    className={classes.refresh}
                >
                    {t('errorPage.refreshMessage')}
                </span>

                <span>
                    {t('errorPage.messagePart2')}
                </span>
            </div>

            {!iFrameAdmission &&
                <AgyleButton
                    variant="contained"
                    onClick={handleGoBack}
                >
                    {t('errorPage.button')}
                </AgyleButton>
            }
        </div>
    );
};

export default DefaultErrorPage;